export const PROJECT_TREE = 'PROJECT_TREE';
export const PROJECT_TREE_SUCCESS = 'PROJECT_TREE_SUCCESS';
export const PROJECT_TREE_ERROR = 'PROJECT_TREE_ERROR';
